// export const BASE_URL = "http://localhost:8080";
export const BASE_URL = "https://api.globelinkplacement.com";

export const generateTransactionId = () => {
  const timestamp = Date.now().toString();
  const randomDigits = Math.floor(1000 + Math.random() * 9000).toString();
  return timestamp.slice(-9) + randomDigits;
};

export const generateConsumerId = () => {
  const charset = "abcdefghijklmnopqrstuvwxyz0123456789";
  const length = 19; // Set length to 19 because 'c' will be at the beginning
  let consumerId = "c"; // Start the ID with 'c'

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    consumerId += charset[randomIndex];
  }

  return consumerId;
};

export const formatDebitDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0"); // Ensure two-digit day
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two-digit month
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const formatDate = (date) => {
  if (!date) return ""; // Handle empty or undefined date

  const newDate = new Date(date);
  if (isNaN(newDate)) return ""; // Handle invalid dates

  const day = String(newDate.getDate()).padStart(2, "0");
  const month = String(newDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = newDate.getFullYear();

  return `${day}-${month}-${year}`;
};

export const getEndDate = (startDate) => {
  const start = new Date(startDate);
  start.setFullYear(start.getFullYear() + 39); // Add 40 years

  const day = String(start.getDate()).padStart(2, "0");
  const month = String(start.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = start.getFullYear();

  return `${day}-${month}-${year}`;
};
